import "./interests.scss";
type InterestsProps = {};

const Interests = (props: InterestsProps) => {
  return (
    <>
      <div className="future-plans page">
        <div className="future-plans__header page__header">
          <h1 className="future-plans__header__title page__header__title">
            ЗАНИМАНИЯ ПО ИНТЕРЕСИ
          </h1>
        </div>
        <div className="future-plans__body">
          <ul className="future-plans__body__content">
            <li className="future-plans__body__content__item">
              <p>
                Заниманията по интереси спомагат организацията на свободното
                време на учениците така ,че те да реализират потребностите си от
                изява и творческа свобода, да разгънат интересите, мислите и
                въображението си
              </p>
            </li>
            <li className="future-plans__body__content__item">
              <p>
                Заниманията по интереси дават възможност за повишаване на
                ефикасността на вътрешно колективните личностни отношения и да
                създават условия за обмяна на знания , опит и ценности.
              </p>
            </li>
            <li className="future-plans__body__content__item">
              <p>
                С нетрадиционни форми на работа се предизвиква у учениците
                радост и удовлетворение от училищния живот и от техния личен
                принос за обогатяването му.
              </p>
            </li>
            <li className="future-plans__body__content__item">
              <p>
                Заниманията по интереси спомагат за нравственото и естетическо
                възпитание на учениците, а също така и за усъвършенстване на
                навиците им за работа в екип.
              </p>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Interests;
